import { render, staticRenderFns } from "./Interfaces-Edit.vue?vue&type=template&id=22e4ea70&"
import script from "./Interfaces-Edit.vue?vue&type=script&lang=js&"
export * from "./Interfaces-Edit.vue?vue&type=script&lang=js&"
import style0 from "./Interfaces-Edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports